import React, { ReactElement } from 'react';
import { useGetDocumentationQuery } from '../../../../../../../../redux/configuration/documentation/api';
import { sessionApi } from '../../../../../../../../redux/views/session-view/session/api/api';
import { Documents } from '.';

type DCloudDocumentsProps = {
  sessionUid: string;
  versionUid: string;
};

export function ConnectedDCloudDocuments({
  sessionUid,
  versionUid,
}: DCloudDocumentsProps): ReactElement {
  const {
    documents,
    isLoading: isLoadingDocuments,
    isFetching: isFetchingDocuments,
    isError: isErrorDocuments,
    topologyUid,
  } = sessionApi.endpoints.getSession.useQueryState(
    { sessionUid, versionUid },
    {
      selectFromResult: ({ data, isLoading, isFetching, isError }) => ({
        documents: data?.sessionDetails.documents,
        isError,
        isFetching,
        isLoading,
        topologyUid: data?.topology.uid,
      }),
    },
  );

  const {
    data: documentation,
    isLoading: isLoadingDocumentation,
    isFetching: isFetchingDocumentation,
    isError: isErrorDocumentation,
  } = useGetDocumentationQuery(topologyUid!);

  return (
    <Documents
      documents={documents}
      isLoading={
        isLoadingDocuments ||
        isFetchingDocuments ||
        isLoadingDocumentation ||
        isFetchingDocumentation
      }
      isError={isErrorDocuments || isErrorDocumentation}
      documentationUrl={documentation?.documentationUrl}
    />
  );
}
